module.exports = __webpack_public_path__ + "img/P5181325.1fac62fe.jpg";